import { render } from "./BlogAddNews.vue?vue&type=template&id=1bc0474a"
import script from "./BlogAddNews.vue?vue&type=script&lang=js"
export * from "./BlogAddNews.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__